export const getEmailListItem = ({ title, description, chip, index }) => `
            <tr>
                <td
                style="
                    font-size: 0px;
                    padding: 20px 0;
                    padding-top: 0;
                    padding-right: 4px;
                    padding-bottom: 0;
                    padding-left: 4px;
                    word-break: break-word;
                "
                data-testid="email-list-item-${index + 1}"
                >
                <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:598px;" width="598" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
                <div
                    style="margin: 0px auto; max-width: 598px; ${
                      index !== 0 ? `margin-top: 4px;` : ""
                    }"
                >
                    <table
                    align="center"
                    border="0"
                    cellpadding="0"
                    cellspacing="0"
                    role="presentation"
                    style="width: 100%"
                    >
                    <tbody>
                        <tr>
                        <td
                            style="
                            direction: ltr;
                            font-size: 0px;
                            padding: 20px 0;
                            padding-bottom: 0;
                            padding-left: 4px;
                            padding-right: 4px;
                            padding-top: 0;
                            text-align: center;
                            "
                        >
                            <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:590px;" ><![endif]-->
                            <div
                            class="mj-column-per-100 mj-outlook-group-fix"
                            style="
                                font-size: 0px;
                                text-align: left;
                                direction: ltr;
                                display: inline-block;
                                vertical-align: top;
                                width: 100%;
                            "
                            >
                            <table
                                border="0"
                                cellpadding="0"
                                cellspacing="0"
                                role="presentation"
                                style="
                                background-color: #ffffff;
                                vertical-align: top;
                                "
                                width="100%"
                            >
                                <tbody>
                                <tr>
                                    <td
                                    align="left"
                                    style="
                                        font-size: 0px;
                                        padding: 10px 25px;
                                        padding-right: 8px;
                                        padding-bottom: 4px;
                                        padding-left: 8px;
                                        word-break: break-word;
                                    "
                                    >
                                    <div
                                        style="
                                        font-family: Roboto, Arial;
                                        font-size: 12px;
                                        font-weight: 600;
                                        line-height: 1;
                                        text-align: left;
                                        color: #000000;
                                        "
                                    >
                                        <span
                                        class="section-header-icon section-header-badge"
                                        style="
                                            width: 14px;
                                            height: 14px;
                                            border-radius: 50%;
                                            display: inline-block;
                                            text-align: center;
                                            font-size: 10px;
                                            line-height: 14px;
                                            margin-right: 4px;
                                            background-color: #e0f7fa;
                                            color: #006064;
                                        "
                                        >${index + 1}</span>
                                        ${title}
                                        ${
                                          chip
                                            ? `<span
                                        class="section-header-icon section-header-badge"
                                        style="
                                            border-radius: 2px;
                                            display: inline-block;
                                            text-align: center;
                                            font-size: 11px;
                                            font-weight: 400;
                                            line-height: 14px;
                                            margin-left: 4px;
                                            padding: 0 4px;
                                            background-color: ${chip.colors?.background};
                                            color: #fff;
                                            border: 1px solid ${chip.colors?.border};
                                        "
                                        >${chip.label}</span>`
                                            : ""
                                        }
                                    </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                    align="left"
                                    style="
                                        font-size: 0px;
                                        padding: 10px 25px;
                                        padding-right: 8px;
                                        padding-left: 8px;
                                        word-break: break-word;
                                    "
                                    >
                                    <div
                                        style="
                                        font-family: Roboto, Arial;
                                        font-size: 12px;
                                        line-height: 1;
                                        text-align: left;
                                        color: #263238;
                                        "
                                    >
                                        ${description}
                                    </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            </div>
                            <!--[if mso | IE]></td></tr></table><![endif]-->
                        </td>
                        </tr>
                    </tbody>
                    </table>
                </div>
                <!--[if mso | IE]></td></tr></table><![endif]-->
                </td>
            </tr>
`;

export const getEmailList = (items) =>
  items.map((item, index) => getEmailListItem({ ...item, index })).join("");
